import "./App.css";
import { useState, useRef } from "react";
import "./assets/css/card.css";
import VisitingCard from "./component/eventcards/VisitingCard";
import ExhibitingCard from "./component/eventcards/ExhibitingCard";
import ExhibitinginWomenPCard from "./component/eventcards/ExhibitinginWomenPCard";
import "./assets/css/cardPrint.css";
import { IoIosPrint } from "react-icons/io";
import { toJpeg } from "html-to-image";

function App() {
  const [option, setOption] = useState("VISITING");
  const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const [error, setError] = useState({
    name:"",
    image:""
  });


  // Function to print the content
  // const handlePrint = () => {
  //   let formIsValid = true;
  //   setError({
  //     name: "",
  //     image: ""
  //   });
  //   if (option === "VISITING") {
  //     if (!image) {
  //       setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
  //       formIsValid = false;
  //     }
  //   } else {
  //     if (!name) {
  //       setError(prevState => ({ ...prevState, name: "Please enter your name before printing." }));
  //       formIsValid = false;
  //     }
  //     if (!image) {
  //       setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
  //       formIsValid = false;
  //     }
  //   }
  //   if (formIsValid) {
  //     window.print();
  //   }
  // };

  const cardRef = useRef(); // Reference to the visiting card container

  const handleDownload = () => {
    let formIsValid = true;
    setError({
      name: "",
      image: ""
    });
    if (option === "VISITING") {
      if (!image) {
        setError((prevState) => ({
          ...prevState,
          image: "Please upload an image."
        }));
        formIsValid = false;
        window.alert("Please upload an image.");
      }
    } else {
      if (!name) {
        setError((prevState) => ({
          ...prevState,
          name: "Please enter company name."
        }));
        formIsValid = false;
        window.alert("Please enter company name.");
      }
      if (!image) {
        setError((prevState) => ({
          ...prevState,
          image: "Please upload an image."
        }));
        formIsValid = false;
        window.alert("Please upload an image.");
      }
    }
  
    if (formIsValid) {
      const deleteIcons = cardRef.current.querySelectorAll(".deleteIcon");
      deleteIcons.forEach((icon) => icon.classList.add("hidden-during-download"));

    if (cardRef.current) {
      toJpeg(cardRef.current, { quality: 0.95 })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = `${option}-card.jpg`; // Dynamic filename based on option
          link.click();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Failed to generate image:", error);
        });
    }
   }
  };

  const handlePrint = () => {
    let formIsValid = true;
    setError({
      name: "",
      image: ""
    });
    if (option === "VISITING") {
      if (!image) {
        setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
        formIsValid = false;
      }
    } else {
      if (!name) {
        setError(prevState => ({ ...prevState, name: "Please enter your name before printing." }));
        formIsValid = false;
      }
      if (!image) {
        setError(prevState => ({ ...prevState, image: "Please upload an image before printing." }));
        formIsValid = false;
      }
    }

    if (formIsValid) {
    const printContent = cardRef.current; 
    const originalContent = document.body.innerHTML; 
    document.body.innerHTML = printContent.outerHTML;
    window.print(); 
    document.body.innerHTML = originalContent;
    window.location.reload();
    }
  };

  const handleOptionChange=(e)=>{
    setOption(e.target.value);
    setImage(null);
    setName("");
    setError({
      name: "",
      image: ""
    });
  }

  return (
    <div>
      <div className="background-style">
        <div className="flex flex-col md:flex-row justify-center items-center md:gap-6 dropdown-section">
          <div className="d-flex mt-9">
            <label className="block mb-2 text-sm font-medium text-white dark:text-white"> Select an option </label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onChange={handleOptionChange}>
              <option selected disabled>Choose a option</option>
              <option selected={option === "VISITING"} value="VISITING">
                I AM VISITING
              </option>
              <option value="EXHIBITING">I AM EXHIBITING</option>
              <option value="EXHIBITING_IN_WOMEN_PAVILLION">
                I AM EXHIBITING IN WOMEN PAVILLION
              </option>
            </select>
          </div>
          {/* <button className="text-white mt-16" onClick={handlePrint} title="Print">
             <IoIosPrint color="white" size={24}/>
          </button> */}

           <button
            className="text-white mt-4 md:mt-16 ml-4 bg-blue-500 p-2 rounded"
            onClick={handleDownload}>
            Download
          </button>
        </div>

        <div className="flex justify-center mt-8">
          {option === "VISITING" ? (
            <div className="" ref={cardRef}>
              <VisitingCard image={image} setImage={setImage} error={error} setError={setError}/> {/* Wrap content with ref */}
            </div>
          ) : option === "EXHIBITING" ? (
            <div ref={cardRef}>
              <ExhibitingCard image={image} setImage={setImage} name={name} setName={setName} error={error} setError={setError}/>
            </div>
          ) : option === "EXHIBITING_IN_WOMEN_PAVILLION" ? (
            <div ref={cardRef}>
             <ExhibitinginWomenPCard image={image} setImage={setImage} name={name} setName={setName} error={error} setError={setError}/>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
